
import { StdResponse, request } from "@/global/config/request";


export function getSystemLogs(projectId: number, params?: {}): Promise<StdResponse<any>> {
    return request.get(`/project/${projectId}/system-logs`, {
        params: {
            ...params,
        }
    })
}